import React, { useState } from 'react';
import './ContactWidget.less';

const contactList = [
  {
    id: 'xiaohongshu',
    icon: '/images/home/xiaohongshu-icon.png',
    qrCode: '/images/home/qr-xiaohongshu.png',
  },
  {
    id: 'wechat',
    icon: '/images/home/wechat-icon.png',
    qrCode: '/images/home/qr-wechat.jpg',
  },
  {
    id: 'kefu',
    icon: '/images/home/kefu-icon.png',
    qrCode: '/images/home/qr-kefu.png',
  },
];

function ContactWidget() {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div className="contact-widget">
      {contactList.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 && <div className="contact-widget-divider"></div>}
          <div
            className="contact-widget-item"
            onMouseEnter={() => setHoveredId(item.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            <div className="contact-widget-icon">
              <img src={item.icon} alt='' />
            </div>
            {hoveredId === item.id && (
              <div className="contact-widget-popup">
                <div className="contact-widget-qrBlock">
                  <img src={item.qrCode} alt='' />
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default ContactWidget;